import { createUseStyles } from "react-jss";
import { colors } from "../../../../../constants/colors";

const styles = createUseStyles(theme => ({
  input: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    minHeight: "120px",
    margin: "0 auto",
    position: "relative",
    boxSizing: "border-box",
    transition: "all .15s linear",
    border: "1px solid " + colors.lightGrey,
    borderRadius: "12px",
    padding: "16px 24px", 
    fontSize: "14px",
    cursor: "pointer",
    "& a": {
      color: `${theme.uploadModal.linkColor} !important`,
      fontWeight: "600",
      lineHeight: "20px"
    },
    "& p": {
      marginBottom: "4px"
    }
  },
  uploadIcon: {
    marginBottom: "12px"
  },
  csvText: {
    fontSize: "12px",
    lineHeight: "18px"
  }
}))

export default styles;
